// extracted by mini-css-extract-plugin
export var container = "_lr-0";
export var segment = "_lr-2";
export var segmentActive = "_lr-3";
export var track = "_lr-1";